// 自动生成的ppt模板数据
const ppt = [
  {
    "id": "6347cf8e7b425a6485c45b53",
    "page": "ppt-1.html",
    "title": "动态毕业设计答辩PPT模板"
  },
  {
    "id": "6349099c044b853dd1b128d5",
    "page": "ppt-2.html",
    "title": "简约动感莫兰迪配色工作总结计划PPT模板"
  },
  {
    "id": "63490be2044b853dd1b12923",
    "page": "ppt-3.html",
    "title": "炫彩抽象图案背景时尚商务汇报PPT模板"
  },
  {
    "id": "63491507a6d8d129f58faf89",
    "page": "ppt-4.html",
    "title": "卡通开学季主题班会PPT模板"
  },
  {
    "id": "63491de5a6d8d129f58fb1d5",
    "page": "ppt-5.html",
    "title": "卡通太空风神舟十四号载人航天飞船PPT模板"
  },
  {
    "id": "634cf83aa6d8d129f58fe826",
    "page": "ppt-6.html",
    "title": "实用创业商业计划书PPT模板"
  },
  {
    "id": "634cf9dda6d8d129f58fe884",
    "page": "ppt-7.html",
    "title": "素雅杂志风家具促销活动策划PPT模板"
  },
  {
    "id": "634cfaf8a6d8d129f58fe8a2",
    "page": "ppt-8.html",
    "title": "中式室内设计装修效果展示PPT模板"
  },
  {
    "id": "634d1103a6d8d129f58febee",
    "page": "ppt-9.html",
    "title": "蓝色简约互联网大数据主题PPT模板下载"
  },
  {
    "id": "634fadf91a37edd374abc112",
    "page": "ppt-10.html",
    "title": "橙色圆点圆圈背景的年度工作总结PPT模板"
  },
  {
    "id": "634faf511a37edd374abc1da",
    "page": "ppt-11.html",
    "title": "简约清新蓝粉配色个人简历PPT模板"
  },
  {
    "id": "634fb06e1a37edd374abc296",
    "page": "ppt-12.html",
    "title": "深蓝色女生个人简历PPT模板"
  },
  {
    "id": "634fb16f1a37edd374abc2f2",
    "page": "ppt-13.html",
    "title": "彩色扁平化电脑桌背景个人简历PPT模板"
  },
  {
    "id": "6350faa67594a9a5c6076073",
    "page": "ppt-14.html",
    "title": "玫红色国潮戏曲主题PPT模板"
  },
  {
    "id": "63510a037594a9a5c60763e4",
    "page": "ppt-15.html",
    "title": "不忘初心牢记使命爱国主义教育PPT模板"
  },
  {
    "id": "6351100b7594a9a5c607653a",
    "page": "ppt-16.html",
    "title": "大气雪山背景商务PPT模板"
  },
  {
    "id": "635259c97594a9a5c6077c0d",
    "page": "ppt-17.html",
    "title": "橙色简约时尚企业介绍PPT模板"
  },
  {
    "id": "63525aa17594a9a5c6077c58",
    "page": "ppt-18.html",
    "title": "不忘初心勇担当党建"
  },
  {
    "id": "63562ef47594a9a5c607b09e",
    "page": "ppt-19.html",
    "title": "橙色矢量扁平化公司管理制度培训PPT模板"
  },
  {
    "id": "63562feb7594a9a5c607b0e9",
    "page": "ppt-20.html",
    "title": "情商管理与沟通技巧培训PPT模板"
  },
  {
    "id": "6356310e7594a9a5c607b0f8",
    "page": "ppt-21.html",
    "title": "蓝色极简企业管理培训PPT模板"
  },
  {
    "id": "635632b57594a9a5c607b13b",
    "page": "ppt-22.html",
    "title": "卡通“开学啦”小学开学第一课PPT模板"
  },
  {
    "id": "635778550d28f6f5a99e1dc4",
    "page": "ppt-23.html",
    "title": "学术大答辩毕业答辩PPT模板"
  },
  {
    "id": "635779f90d28f6f5a99e1e0b",
    "page": "ppt-24.html",
    "title": "精美实用微立体论文答辩PPT模板"
  },
  {
    "id": "63577b660d28f6f5a99e1e1d",
    "page": "ppt-25.html",
    "title": "苹果IOS风论文答辩PPT模板"
  },
  {
    "id": "63577cfc0d28f6f5a99e1e5f",
    "page": "ppt-26.html",
    "title": "精美实用动态论文答辩PPT模板"
  },
  {
    "id": "6357a4725c66399fa5a2a164",
    "page": "ppt-27.html",
    "title": "中国风商务汇报PPT模板"
  }
];

export default ppt;